export default __webpack_public_path__ + "static/media/480_store04-it-web.30f61516.png";